import { render, staticRenderFns } from "./smartPractice.vue?vue&type=template&id=a057e656&scoped=true"
import script from "./smartPractice.vue?vue&type=script&lang=js"
export * from "./smartPractice.vue?vue&type=script&lang=js"
import style0 from "./smartPractice.vue?vue&type=style&index=0&id=a057e656&lang=scss"
import style1 from "./smartPractice.vue?vue&type=style&index=1&id=a057e656&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a057e656",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a057e656')) {
      api.createRecord('a057e656', component.options)
    } else {
      api.reload('a057e656', component.options)
    }
    module.hot.accept("./smartPractice.vue?vue&type=template&id=a057e656&scoped=true", function () {
      api.rerender('a057e656', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/practice/smartPractice.vue"
export default component.exports